import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconTechnicianRed from "../media/icons/technician-red.png"
import iconTechnicianWhite from "../media/icons/technician-white.png"
import {parseUrlParams} from "../api/common";

/**
 * @property mainButtonOnClick - Big red button onclick listener
 * @property mainButtonTextResource - Big red button text resource
 * @property backButtonOnClick - Back arrow button onclick listener. If this is set, the back button will be shown, otherwise it will be hidden
 * @property additionalText - If this is provided, the big red button will be slightly smaller and some extra text will be shown next to it
 */
class BottomBarPassive extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            buttonContent: <Button className={"button-red width-100"}
                                   style={{height:"48px"}}
                                   onClick={this.confirm}>
                {i18n.t(this.props.buttonTextResource, this.props)}
            </Button>
        };
    }

    confirm = () => {
        this.setState({
            buttonContent: <Button className={"button-red width-100"}
                                   style={{height:"48px"}}>
                <span><img src={iconTechnicianWhite} style={{height:"24px",width:"24px",marginTop:"-4px"}} /></span>
                {i18n.t("confirm_thanks")}
            </Button>
        })
        this.props.buttonOnClick();
    };

    render() {
        let button;
        if(this.props.buttonOnClick){
            button = this.state.buttonContent
        }else{
            button = <p  className={"text-bottom-bar-small"}>{i18n.t("Termin wird geprüft")}</p>
        }


        let content;
        content=<Row>
            <Col xs={2}>
                <img src={iconTechnicianRed} style={{height:"48px",width:"48px"}} />
            </Col>
            <Col xs={5}>
                <p className={"text-bottom-bar-regular text-bottom-bar-bold"} style={{height:"28px", marginBottom:"0"}}>
                    {this.props.dateText}
                </p>
                <p className={"text-bottom-bar-regular"} style={{height:"28px"}}>
                    {i18n.t(this.props.timeText, this.props)}
                </p>
            </Col>
            <Col xs={5}>
                {button}
            </Col>
        </Row>;



        return <Container className={"round-corners shadow bottom-bar bg-white"} style={{marginTop:"16px"}}>
            {content}
        </Container>
    }
}

export default translate("translations")(BottomBarPassive);